import { numberMoney } from 'Data/format.js'
import { TRANSACTION_DTYPE } from 'Data/payments.js'

export function getAmount(entry) {
  return numberMoney(
    Math.abs(
      entry.transactions.reduce(
        (acc, transaction) => acc + transaction.amount,
        0
      )
    )
  )
}

export function getDescription(entry) {
  return entry.transactions
    .map(
      transaction =>
        `${getAdjustmentName(transaction)} (${numberMoney(transaction.amount)})`
    )
    .join(' + ')
}

function getAdjustmentName(transaction) {
  switch (transaction.dtype) {
    case TRANSACTION_DTYPE.WriteOff:
      return 'Write off'
    case TRANSACTION_DTYPE.DiscountAdjustment:
      return `${transaction.discount_adjustment.discount.name || 'Discount'}`
    case TRANSACTION_DTYPE.DiscountReverseAdjustment:
      return `${transaction.discount_reverse_adjustment.discount_adjustment.discount.name || 'Discount'} - Reversed`
    default:
      return transaction.dtype
  }
}
